import React, { useState } from "react";

const OrderSummary = ({ orderItems }) => {

  const subtotal = orderItems.reduce((total, item) => total + item.productId.discountedPrice * item.quantity, 0);
  const shipping = "Free Shipping within India";
  const estimatedDispatch = "Mon, 06 Jan 2025 - Wed, 15 Jan 2025";
  const total = subtotal; // Assuming no extra charges for simplicity

  return (
    <div className="max-w-4xl mx-auto mt-10 p-6 bg-white shadow-lg rounded-md">
      <h2 className="text-lg font-bold mb-4">Your Order</h2>
      <div className="mb-4">
        {orderItems.map((item) => (
          <div
            key={item.cartItemId}
            className="flex items-center justify-between border-b py-4"
          >
            <div className="flex items-center space-x-4">
              <img
                src={item?.productId?.images[0]}
                alt={item?.productId?.title}
                className="w-16 h-16 rounded-md object-cover"
              />
              <div>
                <p className="font-medium">{item?.productId?.title}</p>
                <p className="text-sm text-gray-500">Brand: {item?.productId?.brand}</p>
                <p className="text-sm text-gray-500">Size: {item?.size}</p>
                <p className="text-sm text-gray-500">Quantity: {item?.quantity}</p>
                <p className="text-sm text-gray-500">Color: {item?.color}</p>
              </div>
            </div>
            <p className="font-medium">₹{item?.productId?.discountedPrice.toLocaleString()}</p>
          </div>
        ))}
      </div>
      <div className="text-left space-y-2">
        <p className="text-gray-700">Subtotal: ₹{subtotal.toLocaleString()}</p>
        <p className="text-gray-700">Shipping: {shipping}</p>
        <p className="text-gray-700">Estimated Dispatch: {estimatedDispatch}</p>
        <p className="font-bold text-lg">Total: ₹{total.toLocaleString()}</p>
      </div>
    </div>
  );
};

export default OrderSummary;
